import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = {
  class: "setup-wizard",
  "data-testid": "marketing-campaign-setup-wizard"
}
const _hoisted_2 = { class: "checklist" }
const _hoisted_3 = {
  id: "marketing-setup-targets",
  class: "campaign-setup-targets"
}
const _hoisted_4 = { class: "campaign-setup-grid" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = ["value"]
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { class: "scope-title" }
const _hoisted_10 = ["data-testid"]
const _hoisted_11 = ["data-testid"]
const _hoisted_12 = {
  key: 1,
  class: "scope-grid"
}
const _hoisted_13 = { class: "checkbox-field" }
const _hoisted_14 = ["onUpdate:modelValue", "data-testid"]
const _hoisted_15 = ["onUpdate:modelValue"]
const _hoisted_16 = {
  key: 2,
  class: "scope-grid"
}
const _hoisted_17 = ["onUpdate:modelValue"]
const _hoisted_18 = {
  key: 3,
  class: "scope-grid"
}
const _hoisted_19 = ["onUpdate:modelValue", "data-testid"]
const _hoisted_20 = ["disabled", "data-testid", "onClick"]
const _hoisted_21 = {
  key: 4,
  class: "official-import"
}
const _hoisted_22 = ["disabled", "onChange"]
const _hoisted_23 = { class: "import-period" }
const _hoisted_24 = ["onUpdate:modelValue"]
const _hoisted_25 = ["onUpdate:modelValue"]
const _hoisted_26 = ["disabled", "onClick"]
const _hoisted_27 = { key: 0 }
const _hoisted_28 = {
  key: 0,
  class: "empty"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ScopeField = _resolveComponent("ScopeField")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("header", null, [
      _cache[3] || (_cache[3] = _createElementVNode("div", null, [
        _createElementVNode("p", { class: "eyebrow" }, "Phase 1 setup"),
        _createElementVNode("h2", null, "記事提案・週次判断の設定ウィザード"),
        _createElementVNode("p", null, "4つの前提と、接続ごとの計測範囲を固定します。未設定のまま汎用記事案は生成しません。")
      ], -1)),
      _createElementVNode("span", {
        class: _normalizeClass(['readiness', _ctx.setupReady ? 'ready' : 'missing'])
      }, _toDisplayString(_ctx.setupReady ? "提案可能" : "設定が必要"), 3)
    ]),
    _createElementVNode("ol", _hoisted_2, [
      _createElementVNode("li", {
        class: _normalizeClass({ done: _ctx.hasKeywords })
      }, "獲得目標キーワード", 2),
      _createElementVNode("li", {
        class: _normalizeClass({ done: _ctx.goalConfigured })
      }, "施策目標", 2),
      _createElementVNode("li", {
        class: _normalizeClass({ done: _ctx.targetUrls.length > 0 })
      }, "対象URL", 2),
      _createElementVNode("li", {
        class: _normalizeClass({ done: !!_ctx.finalConversionEvent })
      }, "最終成果イベント", 2)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _cache[7] || (_cache[7] = _createElementVNode("h3", null, "対象URL・最終成果", -1)),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("label", null, [
          _cache[4] || (_cache[4] = _createElementVNode("span", null, "対象URL（1行1件）", -1)),
          _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.targetUrlsText) = $event)),
            rows: "4",
            placeholder: "https://example.com/service",
            disabled: _ctx.campaignSaving || !_ctx.campaignWritable
          }, null, 8, _hoisted_5), [
            [_vModelText, _ctx.targetUrlsText]
          ])
        ]),
        _createElementVNode("label", null, [
          _cache[6] || (_cache[6] = _createElementVNode("span", null, "最終成果イベント", -1)),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.finalConversionEvent) = $event)),
            disabled: _ctx.campaignSaving || !_ctx.campaignWritable
          }, [
            _cache[5] || (_cache[5] = _createElementVNode("option", { value: "" }, "選択してください", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.eventOptions, (event) => {
              return (_openBlock(), _createElementBlock("option", {
                key: event.value,
                value: event.value
              }, _toDisplayString(event.label), 9, _hoisted_7))
            }), 128))
          ], 8, _hoisted_6), [
            [_vModelSelect, _ctx.finalConversionEvent]
          ])
        ])
      ]),
      _createElementVNode("button", {
        type: "button",
        disabled: !_ctx.canSaveCampaign,
        "data-testid": "marketing-setup-save-campaign",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.saveCampaignSetup && _ctx.saveCampaignSetup(...args)))
      }, _toDisplayString(_ctx.campaignSaving ? "保存中..." : "対象URLと最終成果を保存"), 9, _hoisted_8)
    ]),
    _cache[17] || (_cache[17] = _createElementVNode("div", {
      id: "marketing-setup-scopes",
      class: "scope-heading"
    }, [
      _createElementVNode("h3", null, "接続別の計測scope"),
      _createElementVNode("p", null, "GA4、GSC、WordPressのresourceと実際に分析するhost・path・URL範囲・timezoneを分けて保存します。未保存の接続には既知データからの提案値を入れます。保存ボタンを押すまで確認済みになりません。")
    ], -1)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scopedIntegrations, (integration) => {
      return (_openBlock(), _createElementBlock("article", {
        key: integration.id,
        class: "scope-card"
      }, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("strong", null, _toDisplayString(integration.provider_label) + " / " + _toDisplayString(integration.external_resource_name || integration.external_resource_id), 1),
          _createElementVNode("span", null, [
            (_ctx.suggestionApplied[integration.id] && !integration.scope_confirmed_at)
              ? (_openBlock(), _createElementBlock("em", {
                  key: 0,
                  class: "suggestion-badge",
                  "data-testid": `marketing-setup-suggestion-badge-${integration.id}`
                }, "提案値（未保存）", 8, _hoisted_10))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(integration.scope_confirmed_at ? "確認済み" : "未確認"), 1)
          ])
        ]),
        (_ctx.suggestionApplied[integration.id] && !integration.scope_confirmed_at && _ctx.suggestions[integration.id])
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "suggestion-sources",
              "data-testid": `marketing-setup-suggestion-sources-${integration.id}`
            }, [
              _createElementVNode("p", null, _toDisplayString(_ctx.suggestions[integration.id].note), 1),
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.suggestions[integration.id].sources, (text, field) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: `source-${field}`
                  }, _toDisplayString(_ctx.fieldLabel(field)) + "：" + _toDisplayString(text), 1))
                }), 128)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.suggestions[integration.id].manual_fields, (text, field) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: `manual-${field}`,
                    class: "manual"
                  }, _toDisplayString(_ctx.fieldLabel(field)) + "：" + _toDisplayString(text), 1))
                }), 128))
              ])
            ], 8, _hoisted_11))
          : _createCommentVNode("", true),
        (integration.provider == 'ga4')
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createVNode(_component_ScopeField, {
                modelValue: _ctx.scopeForms[integration.id].data_stream_id,
                "onUpdate:modelValue": ($event: any) => ((_ctx.scopeForms[integration.id].data_stream_id) = $event),
                label: "data stream ID"
              }, null, 8, ["modelValue", "onUpdate:modelValue"]),
              _createVNode(_component_ScopeField, {
                modelValue: _ctx.scopeForms[integration.id].hostnames,
                "onUpdate:modelValue": ($event: any) => ((_ctx.scopeForms[integration.id].hostnames) = $event),
                label: "対象host（1行1件）",
                multiline: ""
              }, null, 8, ["modelValue", "onUpdate:modelValue"]),
              _createVNode(_component_ScopeField, {
                modelValue: _ctx.scopeForms[integration.id].paths,
                "onUpdate:modelValue": ($event: any) => ((_ctx.scopeForms[integration.id].paths) = $event),
                label: "対象path（1行1件）",
                multiline: ""
              }, null, 8, ["modelValue", "onUpdate:modelValue"]),
              _createElementVNode("label", _hoisted_13, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": ($event: any) => ((_ctx.articleOnlyForms[integration.id]) = $event),
                  type: "checkbox",
                  "data-testid": `marketing-setup-article-only-${integration.id}`
                }, null, 8, _hoisted_14), [
                  [_vModelCheckbox, _ctx.articleOnlyForms[integration.id]]
                ]),
                _cache[8] || (_cache[8] = _createElementVNode("span", null, "このpropertyは記事専用（公開ページURL・サービスLP URLは空で保存）", -1))
              ]),
              _createVNode(_component_ScopeField, {
                modelValue: _ctx.scopeForms[integration.id].public_page_urls,
                "onUpdate:modelValue": ($event: any) => ((_ctx.scopeForms[integration.id].public_page_urls) = $event),
                label: "公開ページURL（1行1件）",
                multiline: "",
                disabled: !!_ctx.articleOnlyForms[integration.id]
              }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]),
              _createVNode(_component_ScopeField, {
                modelValue: _ctx.scopeForms[integration.id].service_lp_urls,
                "onUpdate:modelValue": ($event: any) => ((_ctx.scopeForms[integration.id].service_lp_urls) = $event),
                label: "サービスLP URL（1行1件）",
                multiline: "",
                disabled: !!_ctx.articleOnlyForms[integration.id]
              }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]),
              _createVNode(_component_ScopeField, {
                modelValue: _ctx.scopeForms[integration.id].time_zone,
                "onUpdate:modelValue": ($event: any) => ((_ctx.scopeForms[integration.id].time_zone) = $event),
                label: "timezone",
                placeholder: "GA4管理画面で確認"
              }, null, 8, ["modelValue", "onUpdate:modelValue"]),
              _createVNode(_component_ScopeField, {
                modelValue: _ctx.scopeForms[integration.id].key_event_names,
                "onUpdate:modelValue": ($event: any) => ((_ctx.scopeForms[integration.id].key_event_names) = $event),
                label: "key event名（1行1件）",
                multiline: ""
              }, null, 8, ["modelValue", "onUpdate:modelValue"]),
              _createElementVNode("label", null, [
                _cache[10] || (_cache[10] = _createElementVNode("span", null, "key event確認状態", -1)),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": ($event: any) => ((_ctx.scopeForms[integration.id].key_event_status) = $event)
                }, [...(_cache[9] || (_cache[9] = [
                  _createElementVNode("option", { value: "unknown" }, "未確認", -1),
                  _createElementVNode("option", { value: "not_configured" }, "使わない（GA4 key eventは対象外）", -1),
                  _createElementVNode("option", { value: "confirmed" }, "確認済み", -1)
                ]))], 8, _hoisted_15), [
                  [_vModelSelect, _ctx.scopeForms[integration.id].key_event_status]
                ])
              ])
            ]))
          : (integration.provider == 'gsc')
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createVNode(_component_ScopeField, {
                  modelValue: _ctx.scopeForms[integration.id].canonical_host,
                  "onUpdate:modelValue": ($event: any) => ((_ctx.scopeForms[integration.id].canonical_host) = $event),
                  label: "canonical host"
                }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                _createVNode(_component_ScopeField, {
                  modelValue: _ctx.scopeForms[integration.id].url_prefixes,
                  "onUpdate:modelValue": ($event: any) => ((_ctx.scopeForms[integration.id].url_prefixes) = $event),
                  label: "対象URL範囲（1行1件）",
                  multiline: ""
                }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                _createVNode(_component_ScopeField, {
                  modelValue: _ctx.scopeForms[integration.id].time_zone,
                  "onUpdate:modelValue": ($event: any) => ((_ctx.scopeForms[integration.id].time_zone) = $event),
                  label: "timezone"
                }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                _createElementVNode("label", null, [
                  _cache[12] || (_cache[12] = _createElementVNode("span", null, "生成AI検索レポート", -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": ($event: any) => ((_ctx.scopeForms[integration.id].generative_ai_report_access) = $event)
                  }, [...(_cache[11] || (_cache[11] = [
                    _createElementVNode("option", { value: "unknown" }, "未確認", -1),
                    _createElementVNode("option", { value: "available" }, "利用可能", -1),
                    _createElementVNode("option", { value: "unavailable" }, "利用不可", -1)
                  ]))], 8, _hoisted_17), [
                    [_vModelSelect, _ctx.scopeForms[integration.id].generative_ai_report_access]
                  ])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createVNode(_component_ScopeField, {
                  modelValue: _ctx.scopeForms[integration.id].article_url_prefixes,
                  "onUpdate:modelValue": ($event: any) => ((_ctx.scopeForms[integration.id].article_url_prefixes) = $event),
                  label: "記事URL範囲（1行1件）",
                  multiline: ""
                }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                _createVNode(_component_ScopeField, {
                  modelValue: _ctx.scopeForms[integration.id].time_zone,
                  "onUpdate:modelValue": ($event: any) => ((_ctx.scopeForms[integration.id].time_zone) = $event),
                  label: "timezone"
                }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                _createElementVNode("label", null, [
                  _cache[14] || (_cache[14] = _createElementVNode("span", null, "記事CTA計測タグ（waaq.auto.js）の設置確認", -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": ($event: any) => ((_ctx.scopeForms[integration.id].article_tag_status) = $event),
                    "data-testid": `marketing-setup-article-tag-${integration.id}`
                  }, [...(_cache[13] || (_cache[13] = [
                    _createElementVNode("option", { value: "unknown" }, "未確認", -1),
                    _createElementVNode("option", { value: "installed" }, "設置済み", -1),
                    _createElementVNode("option", { value: "not_installed" }, "未設置（公開HTMLで確認済み）", -1)
                  ]))], 8, _hoisted_19), [
                    [_vModelSelect, _ctx.scopeForms[integration.id].article_tag_status]
                  ])
                ])
              ])),
        _createElementVNode("button", {
          type: "button",
          class: "secondary",
          disabled: _ctx.scopeSavingId == integration.id || !_ctx.integrationWritable,
          "data-testid": `marketing-setup-save-scope-${integration.id}`,
          onClick: ($event: any) => (_ctx.saveScope(integration))
        }, _toDisplayString(_ctx.scopeSavingId == integration.id ? "保存中..." : "この接続scopeを確認・保存"), 9, _hoisted_20),
        (integration.provider == 'gsc')
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _cache[15] || (_cache[15] = _createElementVNode("strong", null, "生成AI検索パフォーマンス（正式exportのみ）", -1)),
              _cache[16] || (_cache[16] = _createElementVNode("p", null, "専用APIが利用可能と確認できるまでは自動取得せず、Search Consoleの正式CSV exportを安全に取り込みます。query・CVには帰属しません。", -1)),
              _createElementVNode("input", {
                type: "file",
                accept: ".csv,text/csv",
                disabled: _ctx.importingIntegrationId == integration.id,
                onChange: ($event: any) => (_ctx.selectImportFile(integration.id, $event))
              }, null, 40, _hoisted_22),
              _createElementVNode("div", _hoisted_23, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": ($event: any) => ((_ctx.importPeriods[integration.id].start) = $event),
                  type: "date",
                  "aria-label": "対象期間開始"
                }, null, 8, _hoisted_24), [
                  [_vModelText, _ctx.importPeriods[integration.id].start]
                ]),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": ($event: any) => ((_ctx.importPeriods[integration.id].end) = $event),
                  type: "date",
                  "aria-label": "対象期間終了"
                }, null, 8, _hoisted_25), [
                  [_vModelText, _ctx.importPeriods[integration.id].end]
                ])
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "secondary",
                disabled: !_ctx.importFiles[integration.id] || _ctx.importingIntegrationId == integration.id || !_ctx.integrationWritable,
                onClick: ($event: any) => (_ctx.importGenerativeAi(integration))
              }, _toDisplayString(_ctx.importingIntegrationId == integration.id ? "取込中..." : "正式exportを取り込む"), 9, _hoisted_26),
              (integration.generative_ai_last_imported_at)
                ? (_openBlock(), _createElementBlock("span", _hoisted_27, "最終取込: " + _toDisplayString(integration.generative_ai_last_imported_at), 1))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]))
    }), 128)),
    (_ctx.scopedIntegrations.length == 0)
      ? (_openBlock(), _createElementBlock("p", _hoisted_28, "GA4、GSC、WordPressを接続すると、ここで計測範囲を確認できます。"))
      : _createCommentVNode("", true),
    (_ctx.message)
      ? (_openBlock(), _createElementBlock("p", {
          key: 1,
          class: _normalizeClass(['message', _ctx.messageKind]),
          role: "status"
        }, _toDisplayString(_ctx.message), 3))
      : _createCommentVNode("", true)
  ]))
}